import { makeStyles } from 'makeStyles';
import { TOOLTIP_BG, WHITE } from 'theme/colors';

export const useStyles = makeStyles<{ checkmarkColor?: string }>()((theme, { checkmarkColor }) => ({
  wtnCheckmark: {
    width: 20,
    height: 20,
    '& path': {
      fill: checkmarkColor,
    },
  },
  wtnTooltip: {
    padding: 5,
    backgroundColor: TOOLTIP_BG,
  },
  wtnTooltipText: {
    color: WHITE,
    fontSize: 12,
    fontWeight: 900,
  },
}));
